import { useMaestroStore } from '../store/maestroStore';
import { useZoneProfileStore } from '../store/zoneProfileStore';
import {
  isUnusableZoneDisplayName,
  resolveZoneDisplayName,
} from './zoneDisplayName';
import { zoneProfileDisplayLabel } from './zoneDisplayFallbacks';

/** Toast/device copy: never a raw UPnP UUID. Prefers zone profile discovered_name. */
export function resolvePlayFailureDeviceName(
  rendererName?: string | null,
  rendererId?: string | null,
): string {
  const store = useMaestroStore.getState();
  const zones = store.discovery?.discoveredZones || [];
  const active = store.discovery?.activeZone;
  const renderer = store.activeConnectorRenderer;
  const zone = (rendererId && (zones.find((z) => z.id === rendererId) || (active?.id === rendererId ? active : null)))
    || (renderer?.id && zones.find((z) => z.id === renderer.id))
    || active
    || { id: rendererId || renderer?.id || '', name: rendererName || renderer?.name || '' };
  const ids = [zone.id, rendererId, renderer?.id].map((id) => String(id || '').trim()).filter(Boolean);
  const aliases = new Set<string>();
  for (const id of ids) {
    const stripped = id.replace(/^uuid:/i, '').replace(/^raat-/i, '');
    aliases.add(id);
    aliases.add(stripped);
    aliases.add(`raat-${stripped}`);
  }
  const profile = useZoneProfileStore.getState().zones.find((p) => {
    const pid = String(p.zone_id || '');
    return aliases.has(pid) || aliases.has(pid.replace(/^raat-/i, '').replace(/^uuid:/i, ''));
  });
  const label = resolveZoneDisplayName(zone, {
    profileDisplayName: zoneProfileDisplayLabel(profile),
    discoveredZones: zones,
    selectedUsbDac: store.selectedUsbDac,
  });
  if (label && !isUnusableZoneDisplayName(label, zone.id)) return label;
  if (rendererName && !isUnusableZoneDisplayName(rendererName, rendererId)) return rendererName.trim();
  return 'your device';
}
